import React from "react";
import { motion } from "framer-motion";

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = React.useState(false);

  React.useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.scrollY > 300);
    };
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <motion.button
      className="fixed bottom-6 right-6 h-10 w-10 text-darkLiver rounded-full border transition z-40"
      onClick={scrollToTop}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: isVisible ? 1 : 0, y: isVisible ? 0 : 20 }}
      whileHover={{ scale: 1.1, y: -5 }}
      transition={{ duration: 0.3, ease: "easeInOut" }}
    >
      <i className="fa-solid fa-arrow-up" />
    </motion.button>
  );
};

export default React.memo(ScrollToTop);
